<template>
  <el-dialog
    width="580px"
    :destroy-on-close="true"
    :append-to-body="true"
    :modal-append-to-body="true"
    :before-close="handleClose"
    :title="title"
    center
    custom-class="axj-web-certs-dialog d2-p-0"
    :visible.sync="show"
  >
    <el-carousel ref="bodyContainer"
                 arrow="never"
                 indicator-position="none"
                 :autoplay="false"
                 class="axj-certs-body"
    >
      <el-carousel-item class="axj-certs-body-item" key="login"  name="login" >
        <axj-login
          :title="title"
          @do-register="handleRegister"
          :wx-union-id="unionId"
          @wx-login="changeActive('wxLogin')"
        />
      </el-carousel-item>
      <el-carousel-item class="axj-certs-body-item" key="register"  name="register" >
        <axj-register
          :phone="registerConf.phone"
          :wx-union-id="registerConf.unionId"
          :code="registerConf.code"
          @to-login="changeActive('login')"
        />
      </el-carousel-item>
      <el-carousel-item class="axj-certs-body-item axj-certs-body-wx-login" key="wxLogin"  name="wxLogin" >
        <axj-wx @do-bind="handleBinding" @to-login="changeActive('login')"/>
      </el-carousel-item>
    </el-carousel>
  </el-dialog>
</template>

<script>
import AxjLogin from "./components/axj-login/index";
import AxjRegister from "./components/axj-register/index";
import Axj_wx_login from "../axj_wx_login/index";
export default {
  name: 'axj-web-certs',
  components: {Axj_wx_login, AxjRegister, AxjLogin},
  props:{
    show:{
      type:Boolean,
      default:false
    },
    title:{
      type:String,
      default:undefined
    },
    active:{
      type:String,
      default:"login"
    },
    wxUnionId:{
      type:String,
      default:undefined
    }
  },
  mounted () {

  },
  data(){
    return{
      unionId:undefined,
      registerConf:{
        phone:"",
        code:"",
        unionId:""
      }
    }
  },
  created () {
  },
  watch:{
    wxUnionId(v){
      this.unionId=v
    }
  },
  methods:{
    handleBinding(form){
      this.unionId=form.wxUnionId
      this.changeActive('login')
    },
    handleRegister(form){
      this.registerConf.phone=form.phone
      this.registerConf.code=form.code
      this.registerConf.unionId=form.wxUnionId
      this.changeActive('register')
    },
    changeActive(v){
      this.$refs.bodyContainer.setActiveItem(v)
    },
    handleClose(){
      this.$emit("update:show",false)
    }
  },
}
</script>

<style lang="scss" slot-scope>

.axj-web-certs-dialog{
  .el-dialog{
    background-color: #F2F5F8;
  }
  .el-dialog__body{
    padding: 4px !important;
    height: 100%;
  }
    top: 60px;
    border-radius: 5px;
    padding: 0;
    .el-dialog__title{
      visibility: hidden;
    }
    .el-dialog__headerbtn{
      visibility: hidden;
    }
    .el-dialog__header{
      display: none;
    }
    height: 400px;
    .axj-certs-body{
      height: 100%;
    }
    .axj-certs-body-item{
      height: 400px;
    }
}


</style>



// WEBPACK FOOTER //
// src/components/axj-web-certs/index.vue